export const API_ENDPOINT = 'https://api.repka.app';
